import Preporucuje from "../Preporucuje/Preporucuje";
import NePreporucuje from "../NePreporucuje/NePreporucuje";
import Korisno from "../Korisno/Korisno";
import { formatDate } from "../../../../../../../common/helper";
import { returnUtisci } from "../../../../../../../pages/api/utisak/get";
import Izmjeni from "../Izmjeni/Izmjeni";
import Link from "next/link";
import { useState } from "react";
import { Odgovor } from "../../../../../../../pages/api/utisak/odgovor";
import { OdgovorResponse } from "../../../../../../../pages/api/utisak/odgovor";
import { slackNoviOdgovorKompanije } from "../../../../../../../lib/slack";
import { discordOdgovorKompanije } from "../../../../../../../lib/discord";
import Alert from "../../../../../../components/Alert/Alert";
import { returnOdgovori } from "../../../../../../../pages/api/utisak/get-odgovor";

export default function Utisak({
    data,
    companyName,
    isEditable,
    isCompanyOwner,
    companyId,
    odgovorKompanije,
}: {
    data: returnUtisci;
    odgovorKompanije?: returnOdgovori;
    companyId: number;
    companyName: string;
    isEditable: boolean;
    isCompanyOwner: boolean;
}) {
    const [ostaviOdgovor, setOstaviOdgovor] = useState(false);
    const [izmjeniOdgovor, setIzmjeniOdgovor] = useState(false);
    const [responseError, setResponseError] = useState("");
    const [sent, setSent] = useState(false);
    const [odgovor, setOdgovor] = useState("");

    const rating = Math.round(
        (data.plata +
            data.razvoj +
            data.odnosi +
            data.tim +
            data.tech +
            data.projekti +
            data.balans +
            data.napredovanje) /
            8
    );

    const companyReply = async () => {
        const formattedData: Odgovor = {
            utisakId: data.id,
            text: odgovor,
            companyId: companyId,
        };

        await fetch("/api/utisak/odgovor", {
            method: izmjeniOdgovor ? "PATCH" : "POST",
            body: JSON.stringify(formattedData),
        })
            .then(async (r) => {
                const odgovor: { data: OdgovorResponse } = await r.json();
                if (r.status === 200) {
                    setResponseError("");
                    setSent(true);
                    if (!izmjeniOdgovor) {
                        slackNoviOdgovorKompanije(odgovor.data);
                        discordOdgovorKompanije(odgovor.data);
                    } else {
                        odustaniOdIzmjene();
                    }
                    window.location.reload();
                } else {
                    setResponseError(odgovor.data as unknown as string);
                }
            })
            .catch((e) => {
                console.log(e);
                setResponseError(JSON.stringify(e));
            });
    };

    const izmjeniOdgovorRecenzije = () => {
        setIzmjeniOdgovor(true);
        setOdgovor(odgovorKompanije.text);
        setOstaviOdgovor(true);
    };

    const odustaniOdIzmjene = () => {
        setIzmjeniOdgovor(false);
        setOdgovor("");
        setOstaviOdgovor(false);
    };

    const { downvotes, upvotes } = data;

    return (
        <>
            <div className="border px-8 md:px-10 py-8 bg-gray-5000 border-gray rounded-md border-b mb-6 relative">
                {data.company && (
                    <h3 className="mb-4">
                        <Link href={`/kompanija/${data.company.slug}`}>
                            {data.company.name}
                        </Link>
                    </h3>
                )}
                {data.preporuka ? <Preporucuje /> : <NePreporucuje />}
                {isEditable && <Izmjeni id={data.id} tip="utisak" />}
                <div className="flex mb-2 ">
                    {Array(5)
                        .fill(0)
                        .map((_, i) => (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6 cursor-pointer"
                                viewBox="0 0 20 20"
                                fill={rating > i ? "#025FFE" : "#ddd"}
                                key={_ + i}
                            >
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                            </svg>
                        ))}
                </div>
                <h3 className="font-medium ">{data.title}</h3>

                <span className="block mb-1">
                    {data.zaposlen
                        ? "Trenutno zaposlen"
                        : "Ne radi više u firmi"}
                </span>
                <span className="block text-sm text-gray-dark">
                    {formatDate(data.createdAt as unknown as string)}
                </span>
                <div className="leading-7 text-gray-dark">
                    <h3 className="mt-3 mb-1 text-black text-lg font-medium">
                        Pozitivno
                    </h3>
                    <p className="whitespace-pre-wrap">
                        {data.prosText ||
                            "- Korisnik nije unio pozitivne strane."}
                    </p>
                </div>
                <div className="leading-7 text-gray-dark">
                    <h3 className="mt-3 mb-1 text-black text-lg font-medium">
                        Negativno
                    </h3>
                    <p className="whitespace-pre-wrap">
                        {data.consText || "- Korisnik nije unio nedostatke."}
                    </p>
                </div>
                <Korisno
                    korisno={{ downvotes, upvotes }}
                    id={data.id}
                    tip="utisak"
                />
                {isCompanyOwner && !odgovorKompanije && (
                    <button
                        onClick={() => setOstaviOdgovor(!ostaviOdgovor)}
                        className="absolute right-5 bottom-5 border text-white bg-blue font-medium border-gray p-2 px-3 rounded text-xs"
                    >
                        <a>Ostavi odgovor</a>
                    </button>
                )}
            </div>
            {odgovorKompanije && (
                <div className="ml-16 mb-8">
                    <div className="border px-8 md:px-10 py-8 bg-gray-5000 border-gray rounded-md border-b mb-6 relative">
                        <h3 className="font-medium mb-2">
                            Odgovor {companyName} kompanije
                        </h3>
                        <span className="block text-sm text-gray-dark">
                            {formatDate(data.createdAt as unknown as string)}
                        </span>
                        <p className="whitespace-pre-wrap mt-4">
                            {odgovorKompanije.text}
                        </p>
                        {isCompanyOwner && !izmjeniOdgovor && (
                            <button
                                onClick={izmjeniOdgovorRecenzije}
                                className="absolute right-5 bottom-5 border text-white bg-blue font-medium border-gray p-2 px-3 rounded text-xs"
                            >
                                <a>Izmjeni</a>
                            </button>
                        )}
                    </div>
                </div>
            )}
            {ostaviOdgovor && (
                <div className="ml-16 mb-8">
                    <h4 className="mb-2">
                        {izmjeniOdgovor ? "Izmjeni" : "Ostavi"} odgovor:
                    </h4>
                    <textarea
                        value={odgovor}
                        onChange={(e) => setOdgovor(e.target.value)}
                        className={`no-resize appearance-none block w-full border border-gray text-gray-dark hover:border-blue rounded-md py-3 px-4 mb-3 leading-tight focus:outline-none h-36 resize-none`}
                    ></textarea>
                    <button
                        onClick={companyReply}
                        className="right-5 bottom-5 p-2 px-4 text-white bg-blue rounded text-xs"
                    >
                        <a>{izmjeniOdgovor ? "Izmjeni" : "Ostavi"} odgovor</a>
                    </button>
                    <button
                        className="ml-5 p-2 px-4 rounded text-white bg-red text-xs"
                        onClick={odustaniOdIzmjene}
                    >
                        Odustani
                    </button>
                </div>
            )}
            {responseError && <Alert message={responseError} type="error" />}
        </>
    );
}
